import { useState } from 'react'
import { useApp } from '../context/AppContext'
import { APP_VERSION } from '../lib/version'

const LOGO = 'https://static.lumi.new/material/1f/1f027f739bb812c447d651aef7dfaf6f.png'
const BG = 'https://static.lumi.new/material/6a/6a4466ce15cfe01c9f47b53f492ac212.avif'
const SUPORTE_URL = 'https://calendly.com/suporter3/agenda'

export default function Login() {
  const { login, usersLoading } = useApp()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setErro('')

    if (!email.trim() || !senha.trim()) {
      setErro('Informe e-mail e senha.')
      return
    }

    if (usersLoading) {
      setErro('Aguarde o carregamento dos usuarios.')
      return
    }

    setLoading(true)
    await new Promise(resolve => setTimeout(resolve, 300))
    const ok = login(email.trim().toLowerCase(), senha)
    setLoading(false)

    if (!ok) {
      setErro('E-mail ou senha incorretos. Verifique os dados e tente novamente.')
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(15,16,17,0.75), rgba(15,16,17,0.88)), url("${BG}")`,
        backgroundColor: '#0f1011',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div style={{ width: 380 }}>
        <div className="card p-6">
          <div className="flex flex-col items-center" style={{ marginBottom: 20 }}>
            <div style={{ width: 200, height: 92, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={LOGO} alt="APP 4S" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
            </div>
          </div>

          <h1 style={{ color: '#f7f8f8', fontSize: 18, fontWeight: 600, marginBottom: 6, textAlign: 'center' }}>
            Acesso ao sistema
          </h1>
          <p style={{ color: '#62666d', fontSize: 13, marginBottom: 20, textAlign: 'center' }}>
            Entre com suas credenciais para continuar.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="label-field">E-mail</label>
              <input
                className="input-field"
                type="email"
                value={email}
                onChange={event => setEmail(event.target.value)}
                placeholder="seu@email.com"
                required
                autoFocus
                autoComplete="email"
              />
            </div>

            <div>
              <label className="label-field">Senha</label>
              <input
                className="input-field"
                type="password"
                value={senha}
                onChange={event => setSenha(event.target.value)}
                placeholder="********"
                required
                autoComplete="current-password"
              />
            </div>

            {erro && (
              <div style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 6, padding: '8px 12px', color: '#f87171', fontSize: 13 }}>
                {erro}
              </div>
            )}

            <button
              className="btn-primary"
              type="submit"
              style={{ marginTop: 4, padding: '10px 16px', fontSize: 14 }}
              disabled={loading || usersLoading}
            >
              {usersLoading ? 'Carregando...' : loading ? 'Verificando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <p style={{ color: '#62666d', fontSize: 12, lineHeight: 1.6, textAlign: 'center', marginTop: 16 }}>
          R3 © 2026 - 4S Engenharia - v {APP_VERSION} -{' '}
          <a
            href={SUPORTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#9ba1a9', textDecoration: 'underline' }}
          >
            Solicitar suporte
          </a>
        </p>
      </div>
    </div>
  )
}